import React, { useState } from 'react';
import { Box, Container, useTheme, useMediaQuery, Typography } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerSettlementTable from '../components/CheckerSettlementTable';
import { Icon } from '@iconify/react';
interface CheckerInboxSettlementProps {
  onLogout: () => void;
}
export const CheckerInboxSettlement: React.FC<CheckerInboxSettlementProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-1391">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-1392" />

      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="checker-settlements" data-id="element-1393" />

      <Box component="main" sx={{
      flexGrow: 1,
      p: {
        xs: 2,
        md: 3
      },
      width: {
        sm: `calc(100% - 240px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-1394">
        <Container maxWidth="xl" disableGutters={isMobile} data-id="element-1395">
          <Box sx={{
          mb: 3
        }} data-id="element-1396">
            <Box sx={{
            width: 42,
            height: 42,
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#0052CC'
          }} data-id="element-1397">
              <Icon icon="lucide:check-square" width={22} height={22} color="white" data-id="element-1398" />
            </Box>
            <Typography variant="h5" fontWeight={700} color="#1F2937" data-id="element-1399">
              Checker Inbox - Settlements
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" data-id="element-1400">
            Review and approve manual settlement requests from makers.
          </Typography>
        </Container>
      </Box>
    </Box>;
};
export default CheckerInboxSettlement;